import { render, staticRenderFns } from "./PrivateConfig.vue?vue&type=template&id=a4b0eca8&scoped=true"
import script from "./PrivateConfig.vue?vue&type=script&lang=js"
export * from "./PrivateConfig.vue?vue&type=script&lang=js"
import style0 from "./PrivateConfig.vue?vue&type=style&index=0&id=a4b0eca8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b0eca8",
  null
  
)

export default component.exports